import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Icon } from "ant-design-vue";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import { Underline } from "tiptap-extensions";
import SingleTextDoc from "./components/single-text-doc";
import { BBold, IItalic } from "./components/extensions";
import { GLUtil } from "commonui";
import TextParagraph from "./components/text-paragraph";

const Extensions = [new SingleTextDoc(), new TextParagraph(), new BBold(), new IItalic(), new Underline()];

@Component({
	components: { EditorContent, EditorMenuBar, Icon }
})
export default class RichTextSingleLineEditor extends Vue {
	@Prop({ default: null }) value!: string;
	@Prop({ default: null }) defaultValue!: string;
	@Prop({ default: false }) trim!: boolean | ((d: string) => string);
	@Prop({ default: true }) autoFocus!: boolean | string;
	public editor: Editor = null;

	isTrimOnBlur() {
		return typeof this.trim === "boolean" ? this.trim : typeof this.trim === "function";
	}
	created() {
		this.editor = new Editor({
			content: this.defaultValue || this.value || "",
			autoFocus: this.autoFocus,
			extensions: Extensions,
			parseOptions: {
				preserveWhitespace: "full"
			},
			plugins: [],
			onBlur: () => {
				let value = this.editor.getHTML() || "";
				if (this.isTrimOnBlur() && /(^\s+)|(\s+$)/g.test(value)) {
					value = typeof this.trim === "boolean" ? value.trim() : this.trim(value);
					this.editor.setContent(value);
				}
				this.$emit("blur", value);
			},
			onUpdate: (d) =>
				Vue.nextTick(() => {
					const value = d.getHTML() || "";
					this.$emit("update:value", value);
					this.$emit("change", { target: { value } });
					this.$emit("input", value);
				})
		});
	}

	@Watch("value")
	onValueChanged() {
		Vue.nextTick(() => {
			if (!GLUtil.isNullOrUndefined(this.value) && this.value.localeCompare(this.editor.getHTML())) {
				this.editor.setContent(this.value);
			}
		});
	}

	beforeDestroy() {
		if (this.editor != null) {
			this.editor.destroy();
		}
	}
}
